import React, { useState } from 'react';
import { Input, Select } from 'antd';
import Form from '../../../../components/Form';
import {
	RssFeedCategoriesEnum,
	RssFeedCategoriesTranslationsEnum,
} from '../../../../enums/rss-feed-categories';
import {
	RssFeedRagionsEnum,
	RssFeedRagionsTranslationsEnum,
} from '../../../../enums/rss-feed-regions';

const DEFAULT_PAGINATION = { pageNumber: 1, pageSize: 12 };

export const RssFeedsFilters = ({ filters, setFilters }) => {
	const [title, setTitle] = useState('');

	return (
		<Form.Container
			style={{ marginTop: 16, padding: '0px 2px' }}
			layout='1fr 1fr 1fr'
			onSubmit={(e) => {
				e.preventDefault();
			}}>
			<Form.Item label='Título'>
				<Input.Search
					size='large'
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					placeholder='G1 Notícias, R7 News, CNN Brasil...'
					defaultValue={filters?.title}
					onSearch={() => {
						setFilters((prev) => ({ ...prev, ...DEFAULT_PAGINATION, title }));
					}}
				/>
			</Form.Item>

			<Form.Item label='Categoria'>
				<Select
					allowClear
					size='large'
					placeholder='Selecione a categoria'
					value={filters.category}
					onChange={(category) =>
						setFilters((prev) => ({ ...prev, ...DEFAULT_PAGINATION, title, category }))
					}>
					{Object.values(RssFeedCategoriesEnum)
						.filter((c) => c !== 'CUSTOM')
						.map((category) => (
							<Select.Option value={category} key={category}>
								{RssFeedCategoriesTranslationsEnum[category]}
							</Select.Option>
						))}
				</Select>
			</Form.Item>

			<Form.Item label='Abrangência'>
				<Select
					allowClear
					size='large'
					placeholder='Selecione a região de abrangência'
					value={filters.region}
					onChange={(region) =>
						setFilters((prev) => ({ ...prev, ...DEFAULT_PAGINATION, title, region }))
					}>
					{Object.values(RssFeedRagionsEnum).map((region) => (
						<Select.Option value={region} key={region}>
							{RssFeedRagionsTranslationsEnum[region]}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
		</Form.Container>
	);
};
